import { render, staticRenderFns } from "./FlyComponent.vue?vue&type=template&id=af487e4c"
import script from "./FlyComponent.vue?vue&type=script&lang=js"
export * from "./FlyComponent.vue?vue&type=script&lang=js"
import style0 from "./FlyComponent.vue?vue&type=style&index=0&id=af487e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports